import { Box } from '@mui/material';
import React from 'react';

import { CommonModal } from '../../../components/modal/modal';

interface PdfPreviewModalProps {
    open: boolean;
    pdfPreviewUrl: string | null;
    onClose: () => void;
    onDownload: () => void;
}

export const PdfPreviewModal: React.FC<PdfPreviewModalProps> = ({ open, pdfPreviewUrl, onClose, onDownload }) => {
    return (
        <CommonModal
            modalOpen={open}
            onCloseModal={onClose}
            primaryBtnClick={onClose}
            secondaryBtnClick={onDownload}
            primaryBtnName="Close"
            secondaryBtnName="Download"
            ModalMaxWidth="90%"
            ModalHeight="90%"
            DialogMainTitle="AutoPay Authorization Document Preview"
            sx={{
                '& .MuiDialogContent-root': {
                    padding: 0,
                    height: 'calc(90% - 120px)',
                    overflow: 'hidden',
                },
            }}
        >
            {pdfPreviewUrl && (
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <embed
                        src={`${pdfPreviewUrl}#toolbar=1`}
                        type="application/pdf"
                        style={{
                            width: '100%',
                            height: '100%',
                            border: 'none',
                        }}
                        title="PDF Preview"
                    />
                </Box>
            )}
        </CommonModal>
    );
};
